import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
const BlogCallToAction = ({ title, btnText, link }) => {
  return (
    <div className="blog-call-to-action">
      <div className="blog-call-to-action__grid">
        <div className="blog-call-to-action__grid-item">
          <h2 className="text-h3 gap-2x text-clr-white text-fw-medium ">
            {title}
          </h2>
          <Link to={`/${link}/`} className="secondary-btn">
            {btnText}
          </Link>
        </div>
        <div className="blog-call-to-action__grid-item">
          <StaticImage src="../images/metrics.png" alt="metrics" />
        </div>
      </div>
    </div>
  );
};

export default BlogCallToAction;
